import React from "react";
import { Settings, Bell } from "react-feather";

import LegionLogo from "../../assets/images/legion-logo.png";

// legion ui
import {
  Anchor,
  Avatar,
  Flex,
  Box,
  Table,
  Text,
  Chip,
  Button,
  Image,
} from "@legion-ui/core";

export const Dashboard = () => {
  return (
    <Box background="#F9FAFB" height="100%">
      <Flex
        padding="12px 24px"
        alignX="space-between"
        background="white"
        direction="row"
      >
        <Anchor href="/">
          <Image width="104px" src={LegionLogo} alt="legion logo" />
        </Anchor>

        <Flex style={{ gap: "2rem" }} alignX="center" alignY="center">
          <Settings size="22" />
          <Bell size="22" />

          <Flex style={{ gap: "8px" }}>
            <Avatar background="#875BF7" text="TW" />
            <Flex direction="column">
              <Text as="p" weight="700" size={["18px", "18px", "18px", "0"]}>
                Alwan Thio
              </Text>
              <Text as="p" size={["18px", "18px", "18px", "0"]}>
                Administrator
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </Flex>

      <Flex margin="24px" background="#fff" padding="16px" radius="8px">
        <Flex direction="column" mb="16px">
          <Text as="h2" size="18px">
            Latest Transaction
          </Text>
          <Text as="p" color="tertiary500" size="14px">
            Your Latest transaction sort by date
          </Text>
        </Flex>
        <Box width="100%" style={{ overflowX: "scroll" }}>
          <Table>
            <React.Fragment key=".0">
              <thead>
                <tr style={{ backgroundColor: "#D0D5DD" }}>
                  <th>ID</th>
                  <th>Customer</th>
                  <th>Date</th>
                  <th>Payment</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>#MB9840</td>
                  <td>Neal Matthews</td>
                  <td>07 Oct, 2021</td>
                  <td>1.000.000</td>
                  <td>
                    <Chip color="success" variant="soft">
                      Delivery
                    </Chip>
                  </td>
                  <td>
                    <Button color="tertiary" variant="outline" size="sm">
                      Detail
                    </Button>
                  </td>
                </tr>
                <tr>
                  <td>#MB9840</td>
                  <td>Jamal Burnett</td>
                  <td>07 Oct, 2021</td>
                  <td>800.000</td>
                  <td>
                    <Chip color="error" variant="soft">
                      Cancelled
                    </Chip>
                  </td>
                  <td>
                    <Button color="tertiary" variant="outline" size="sm">
                      Detail
                    </Button>
                  </td>
                </tr>
                <tr>
                  <td>#MB9840</td>
                  <td>Juan Mitchell</td>
                  <td>07 Oct, 2021</td>
                  <td>800.000</td>
                  <td>
                    <Chip color="error" variant="soft">
                      Cancelled
                    </Chip>
                  </td>
                  <td>
                    <Button color="tertiary" variant="outline" size="sm">
                      Detail
                    </Button>
                  </td>
                </tr>
                <tr>
                  <td>#MB9840</td>
                  <td>Barry Alen</td>
                  <td>07 Oct, 2021</td>
                  <td>800.000</td>
                  <td>
                    <Chip color="error" variant="soft">
                      Cancelled
                    </Chip>
                  </td>
                  <td>
                    <Button color="tertiary" variant="outline" size="sm">
                      Detail
                    </Button>
                  </td>
                </tr>
              </tbody>
            </React.Fragment>
          </Table>
        </Box>
      </Flex>
    </Box>
  );
};

export default Dashboard;
